import { makeStyles } from '@material-ui/core/styles';
import { Font } from '../Font';
import { Color } from '../Color';

const getToastStyled = (color) => ({
  backgroundColor: 'white !important',
  border: `1px solid ${color}`,
  color: `${Color.CloudBurst} !important`,
  position: 'relative',
  fontFamily: Font.Primary,
  fontWeight: 600,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 4,
    height: 'calc(100% - 16px)',
    backgroundColor: color,
    top: '50%',
    left: 4,
    transform: 'translateY(-50%)',
  },
});

export const useStylesToast = makeStyles({
  success: getToastStyled(Color.CaribbeanGreen),
  warning: getToastStyled(Color.NeonCarrot),
  error: getToastStyled(Color.SunsetOrange),
});
